// 吃瓜日报 - 站内编辑内容
// 说明：本站为编辑部自编内容，本地静态数据展示，无需数据库。

export type ChannelKey =
  | 'yule'
  | 'yingshi'
  | 'keji'
  | 'shangye'
  | 'redian';

export interface Channel {
  key: ChannelKey;
  label: string;
  desc: string;
  icon: string;
}

export interface GossipItem {
  slug: string;
  title: string;
  channel: ChannelKey;
  summary: string;
  date: string;
  readTime: number;
  views: number;
  hotTag?: '爆' | '热' | '新';
  tags: string[];
  cover: string;
  author: string;
  content: string[];
}

export const channels: Channel[] = [
  { key: 'yule', label: '娱乐瓜', desc: '明星动态、舞台名场面与热搜背后的故事', icon: 'ri-star-smile-line' },
  { key: 'yingshi', label: '影视综艺', desc: '新剧上线、口碑复盘与节目录制趣闻', icon: 'ri-movie-2-line' },
  { key: 'keji', label: '科技圈', desc: '数码新品、AI 热议与行业动向观察', icon: 'ri-cpu-line' },
  { key: 'shangye', label: '商业瓜', desc: '直播带货、品牌联名与出海生意盘点', icon: 'ri-line-chart-line' },
  { key: 'redian', label: '社会热点', desc: '年轻人生活方式与正在被讨论的现象', icon: 'ri-flood-line' },
];

export const channelLabel = (key: ChannelKey): string =>
  channels.find((c) => c.key === key)?.label || '综合';

export const gossipItems: GossipItem[] = [
  {
    slug: 'ding-liu-zhuan-xing-dian-ying',
    title: '顶流转型试水电影圈：首战票房亮眼，口碑却两极分化',
    channel: 'yule',
    summary: '从唱跳舞台走向大银幕并不容易，这一次转型首战的数据与评论，成了这两天讨论度最高的瓜之一。',
    date: '2026-09-07',
    readTime: 5,
    views: 128400,
    hotTag: '爆',
    tags: ['转型', '电影', '票房', '口碑'],
    cover: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20film%20set%20with%20soft%20golden%20projector%20light%20and%20movie%20clapperboard%2C%20editorial%20magazine%20photography%2C%20cream%20and%20orange%20tonal%20palette%2C%20shallow%20depth%20of%20field%2C%20no%20people%20facing%20camera%2C%20artistic%20and%20clean%20composition&width=800&height=520&seq=chigua-yule-film&orientation=landscape',
    author: '吃瓜·小橘',
    content: [
      '从唱跳舞台跨界到大银幕，从来都不是一蹴而就的事。昨晚新片首映数据一出，粉丝区一片欢呼，而影评区则吵得不可开交——有人说是"完成度超出预期"，也有人直言"演技还是撑不住两个小时"。',
      '抛开立场看数据，首日排片占比近三成、上座率持续走高，说明市场对这个名字的期待值是实打实的。真正决定口碑的，往往是首周末之后的口口相传。',
      '业内人士分析，这类"跨界试水"的票房通常高开，能走多远要看路人盘能否接住。片子排片、档期与题材节奏都压得很稳，后续走势值得继续吃。',
    ],
  },
  {
    slug: 'zongyi-ming-chang-mian-fupan',
    title: '综艺录制现场名场面复盘：一段即兴发挥让整期直接封神',
    channel: 'yule',
    summary: '导演组本没安排这一段，结果成了全网二创素材库，弹幕刷到"全员喜剧人"。',
    date: '2026-09-07',
    readTime: 4,
    views: 89300,
    hotTag: '热',
    tags: ['综艺', '名场面', '即兴', '二创'],
    cover: 'https://readdy.ai/api/search-image?query=bright%20television%20variety%20show%20studio%20stage%20with%20colorful%20set%20decor%20and%20warm%20spotlights%2C%20editorial%20magazine%20photography%2C%20vibrant%20cream%20and%20orange%20tones%2C%20no%20visible%20people%20faces%2C%20energetic%20and%20cheerful%20mood&width=800&height=520&seq=chigua-yule-stage&orientation=landscape',
    author: '吃瓜·果壳',
    content: [
      '这一期的导演大概自己都没想到，原本只是串场的"突发状况"，会贡献出本季播放量最高的一个片段。镜头里几个人相视一眼、接梗甩包袱，节奏快到剪辑都跟不上。',
      '弹幕区从"哈哈哈哈"刷到"这个反应绝了"，当晚相关词条就冲上了热搜。随后大量网友开始二创，短短两天，片段播放量翻了不止一倍。',
      '业内常说"综艺的灵魂在失控的瞬间"，好的即兴不是硬凹梗，而是建立在熟络与信任之上的临场反应。这一期，恰恰证明了这一点。',
    ],
  },
  {
    slug: 'yan-chang-hui-qiang-piao',
    title: '演唱会抢票再上热搜：蹲守 12 小时，抢票软件成了刚需',
    channel: 'yule',
    summary: '开票秒空、回流秒没，抢票大战背后的年轻人，其实是在为一场现场体验拼手速。',
    date: '2026-09-06',
    readTime: 4,
    views: 102100,
    hotTag: '热',
    tags: ['演唱会', '抢票', '现场', '演出经济'],
    cover: 'https://readdy.ai/api/search-image?query=large%20concert%20stadium%20with%20warm%20orange%20stage%20lights%20and%20glowing%20phone%20flashlights%20crowd%20silhouette%2C%20editorial%20night%20photography%2C%20cream%20and%20amber%20tones%2C%20atmospheric%20and%20vibrant&width=800&height=520&seq=chigua-yule-concert&orientation=landscape',
    author: '吃瓜·青柠',
    content: [
      '开票那一刻的页面卡顿，几乎是近两年演出市场的"保留节目"。昨天有粉丝在超话晒出购票记录，蹲守了整整 12 个小时，中间连去洗手间都掐着秒表。',
      '抢票难背后，是现场演出经济的持续火热。演出日历几乎排满全年，可热门场次的票依然供不应求，二手市场的溢价也水涨船高。',
      '对很多年轻人来说，抢到的不仅是那张票，更是一次说走就走的现场奔赴。价格之外，体验与服务是否跟得上，会是这一波演出热潮真正能走多远的关键。',
    ],
  },
  {
    slug: 'gu-zhuang-da-ju-shou-bo',
    title: '年度古装大剧首播数据复盘：热度破纪录背后的三个原因',
    channel: 'yingshi',
    summary: '美术、叙事与选角三种长板齐发力，让这部古装剧一开局就把期待值拉满。',
    date: '2026-09-07',
    readTime: 5,
    views: 176500,
    hotTag: '爆',
    tags: ['古装剧', '首播', '数据', '服化道'],
    cover: 'https://readdy.ai/api/search-image?query=chinese%20ancient%20costume%20drama%20cinematic%20scene%20with%20traditional%20architecture%20courtyard%20and%20red%20lanterns%20in%20warm%20light%2C%20editorial%20drama%20photography%2C%20cream%20orange%20and%20ink%20tonal%20palette%2C%20no%20people%20faces&width=800&height=520&seq=chigua-yingshi-ancient&orientation=landscape',
    author: '吃瓜·小满',
    content: [
      '上线当晚站内热度破纪录，官博一夜涨粉数十万。复盘这部剧的首播数据，你会发现它的成功并非偶然，而是三个长板恰好都在该发力的位置。',
      '其一是美术。从服化道到场景调度，几乎每一帧都在为"质感"服务，观众随手一截就是壁纸。其二是节奏，前三集就交代清楚核心矛盾，信息密度高却不拖沓。',
      '其三是选角与表演的匹配度，演员与角色的贴合度明显经过了用心推敲。当观众不再因出戏而快进，追剧的黏性自然就上来了。至于剧情后续能否保持这个水准，我们继续蹲更新。',
    ],
  },
  {
    slug: 'dou-shi-qing-gan-ju-hui-chun',
    title: '都市情感剧为何再度翻红：编剧谈创作背后的现实洞察',
    channel: 'yingshi',
    summary: '当"悬浮感"被丢掉，观众要的其实是能在剧情里看到自己。',
    date: '2026-09-05',
    readTime: 4,
    views: 65400,
    tags: ['都市剧', '编剧', '创作', '现实主义'],
    cover: 'https://readdy.ai/api/search-image?query=modern%20city%20street%20at%20dusk%20with%20warm%20apartment%20window%20lights%20and%20neon%20glow%2C%20editorial%20film%20still%20photography%2C%20cream%20and%20amber%20tonal%20palette%2C%20cinematic%20and%20moody%20composition&width=800&height=520&seq=chigua-yingshi-urban&orientation=landscape',
    author: '吃瓜·谷雨',
    content: [
      '一度被批"悬浮"的都市情感题材，今年反而密集出圈。究其原因，是越来越多的创作者开始把镜头对准真实的职场压力、代际沟通与亲密关系里的细碎日常。',
      '在一场公开分享里，有编剧坦言："观众不是不爱看爱情，而是不爱看离地三米的生活。"当台词开始讨论房租、KPI 和朋友圈里的人情世故，共情自然就有了。',
      '这一轮"回暖"更像是一次清醒的校准：情感剧不必狗血，只要真诚地讲好普通人如何相爱、相处与成长，就足够打动人心。',
    ],
  },
  {
    slug: 'xuan-yi-duan-ju-hei-ma',
    title: '悬疑短剧黑马出圈：三集讲完一个故事，观众直呼不够看',
    channel: 'yingshi',
    summary: '快节奏、高反转、不注水，这部短剧用"少即是多"重新赢回观众的耐心。',
    date: '2026-09-04',
    readTime: 3,
    views: 73800,
    hotTag: '新',
    tags: ['短剧', '悬疑', '黑马', '节奏'],
    cover: 'https://readdy.ai/api/search-image?query=moody%20dark%20corridor%20with%20warm%20single%20light%20source%20and%20long%20shadows%2C%20editorial%20suspense%20drama%20photography%2C%20cream%20and%20burnt%20orange%20tonal%20palette%2C%20tense%20and%20minimal%20composition&width=800&height=520&seq=chigua-yingshi-suspense&orientation=landscape',
    author: '吃瓜·南枝',
    content: [
      '用三集的体量讲完一个完整且多次反转的悬疑故事，还能让观众意犹未尽——这部小成本短剧最近成了不少人的"电子榨菜"。',
      '它赢在"克制"：不刻意拉长注水，也不堆砌无用的旁支，每一处伏笔都在结尾被收回，剪辑节奏干净利落。',
      '短剧赛道的竞争早已不是拼时长，而是拼信息密度与完成度。这部作品的高分，恰好说明观众从来都不缺耐心，缺的只是值得被尊重的叙事。',
    ],
  },
  {
    slug: 'guo-chan-shou-ji-ying-xiang',
    title: '国产手机影像大战再升级：新款旗舰夜景实测对比',
    channel: 'keji',
    summary: '暗光、高光压制与长焦清晰度，成了这一代旗舰分出高下的三张答卷。',
    date: '2026-09-06',
    readTime: 6,
    views: 96100,
    hotTag: '热',
    tags: ['手机', '影像', '旗舰', '夜景'],
    cover: 'https://readdy.ai/api/search-image?query=closeup%20of%20modern%20smartphone%20rear%20camera%20module%20with%20multiple%20lenses%20on%20warm%20minimal%20surface%2C%20editorial%20tech%20product%20photography%2C%20cream%20and%20orange%20tones%2C%20clean%20and%20precise%20composition&width=800&height=520&seq=chigua-keji-camera&orientation=landscape',
    author: '吃瓜·北屿',
    content: [
      '今年的旗舰大战，战场几乎都集中在了影像。各家发布会不约而同地强调"夜景""长焦"与"计算摄影"，背后是手机摄影从拼参数走向拼算法体验的拐点。',
      '我们把几款主销旗舰拉到同一暗光场景实测：有的靠大底硬吃光量，暗部纯净但高光偶尔溢出；有的则胜在算法，明暗过渡更自然，只是按下快门后要多等一拍。',
      '没有绝对的"最强"，只有取舍的差异。如果你更常拍城市夜景与人物，建议优先看重高光压制与肤色还原；如果常拍远景，长焦的稳定性才是关键。影像没有标准答案，贴合使用习惯的才是好选择。',
    ],
  },
  {
    slug: 'ai-huan-lian-sheng-ji',
    title: 'AI 换脸风波再起：平台升级检测技术，隐私边界被重新讨论',
    channel: 'keji',
    summary: '技术能造脸，也该能识脸。当生成越来越逼真，如何守住"本人同意"这条线？',
    date: '2026-09-05',
    readTime: 5,
    views: 84700,
    tags: ['AI', '换脸', '隐私', '安全'],
    cover: 'https://readdy.ai/api/search-image?query=abstract%20minimal%20portrait%20sculpture%20with%20soft%20warm%20gradient%20light%2C%20editorial%20concept%20photography%20about%20artificial%20intelligence%2C%20cream%20and%20amber%20tonal%20palette%2C%20clean%20and%20thoughtful%20composition&width=800&height=520&seq=chigua-keji-ai&orientation=landscape',
    author: '吃瓜·北屿',
    content: [
      '一段由 AI 生成的高拟真换脸视频近日引发关注，许多网友一度误以为是本人出镜。随后涉事平台紧急上线了更强的合成内容检测与水印标识机制。',
      '技术的两面性在这里体现得淋漓尽致：生成能力的提升让创作门槛一降再降，可一旦用于恶搞、诈骗甚至抹黑，伤害也是实打实的。',
      '业内普遍认为，比"追责"更前置的，是"打标"与"告知"。当一段内容以真人形象出现时，平台有责任让观众知道它是否为合成。而对每一个普通人来说，保护好自己的肖像素材与授权边界，同样刻不容缓。',
    ],
  },
  {
    slug: 'zhe-die-ping-san-xin-pin',
    title: '折叠屏进入普及元年？三款新品横评把性价比聊透',
    channel: 'keji',
    summary: '更薄、更轻、价格更亲民，折叠屏终于从"玩具"走向"日用品"。',
    date: '2026-09-03',
    readTime: 6,
    views: 52300,
    tags: ['折叠屏', '横评', '新品', '性价比'],
    cover: 'https://readdy.ai/api/search-image?query=three%20foldable%20smartphones%20arranged%20on%20warm%20minimal%20desk%20with%20soft%20natural%20light%2C%20editorial%20tech%20product%20photography%2C%20cream%20and%20orange%20tones%2C%20clean%20studio%20composition&width=800&height=520&seq=chigua-keji-fold&orientation=landscape',
    author: '吃瓜·拾一',
    content: [
      '如果把三年前折叠屏比作"尝鲜的玩具"，那么今年这一代，明显冲着"主力机"的身份去了。机身更薄、折痕更浅、价格也第一次进入了不少人的预算区间。',
      '我们把三款主流新品放在一起横评：有的赢在铰链手感与开合流畅度，有的胜在悬停分屏的多任务体验，还有一款则靠更克制的定价抢占入门市场。',
      '折叠屏真正普及，拼的不是一个折叠动作，而是合上够便携、展开够好用的整体体验。如果你已经在两台手机间反复犹豫，不妨先从屏幕素质与售后体系这两个"看不见却常影响体验"的地方入手比较。',
    ],
  },
  {
    slug: 'zhi-bo-jian-jia-ge-wu-long',
    title: '头部直播间的一场价格乌龙：一场"先拍后补"引发的舆论发酵',
    channel: 'shangye',
    summary: '改价失误、客服失联、深夜道歉，一次运营事故如何被放大成全网话题。',
    date: '2026-09-07',
    readTime: 5,
    views: 113200,
    hotTag: '热',
    tags: ['直播', '价格', '电商', '危机公关'],
    cover: 'https://readdy.ai/api/search-image?query=modern%20live%20streaming%20studio%20desk%20with%20ring%20light%20and%20monitor%20showing%20sales%20dashboard%2C%20editorial%20photography%2C%20warm%20cream%20and%20orange%20tones%2C%20clean%20and%20focused%20composition%2C%20no%20people&width=800&height=520&seq=chigua-shangye-live&orientation=landscape',
    author: '吃瓜·青柠',
    content: [
      '一场标价失误，本应是后台就能修复的小问题，却因为"先拍下、后补差"的处理方式，在评论区发酵成了连续两天的热搜话题。',
      '事件本身并不复杂：开播时标价被运营误改，导致大量订单以远低于成本的价格成交。品牌方最初给出的"退差方案"说服力不足，直到深夜才由负责人亲自出面解释并给出补救方案。',
      '复盘下来，真正激怒用户的往往不是价格本身，而是处理过程中的"失声"与"推诿"。危机公关没有捷径，第一时间坦诚、给出可执行的补偿、并快速落实，才是把事故变成信任重建的窗口。',
    ],
  },
  {
    slug: 'xin-nai-cha-lian-ming',
    title: '新茶饮年度联名盘点：谁才是这波营销大战的真正赢家',
    channel: 'shangye',
    summary: '联名不是贴个 logo 就完事，能沉淀出品牌心智的，才是高段位玩法。',
    date: '2026-09-04',
    readTime: 4,
    views: 68900,
    tags: ['新茶饮', '联名', '营销', '品牌'],
    cover: 'https://readdy.ai/api/search-image?query=colorful%20milk%20tea%20cups%20with%20creative%20branding%20sleeves%20arranged%20on%20warm%20cream%20background%2C%20editorial%20product%20photography%2C%20soft%20orange%20and%20cream%20tones%2C%20clean%20and%20playful%20composition&width=800&height=520&seq=chigua-shangye-tea&orientation=landscape',
    author: '吃瓜·谷雨',
    content: [
      '一年到头，新茶饮的联名几乎没停过：动漫、影视、游戏、潮玩……联名款排队买断货的新闻，网友早就见怪不怪。可热闹过后，真正值得追问的是——联名究竟留下了什么。',
      '复盘今年几个出圈的案例会发现，赢家都在做"产品创新 + 情绪共鸣"的组合拳，而非简单贴个角色。有的把 IP 元素融进口味与包装，让粉丝愿意二次晒单；有的则借联名讲述一个能引发讨论的叙事。',
      '对品牌而言，联名是放大器而非遮羞布：产品本身能不能打，决定了热闹能维持多久。一次联名的终点，不应该是排队的队伍散去，而应该是消费者对品牌的记忆多了一层。',
    ],
  },
  {
    slug: 'kuajing-shang-dian-zhan-bao',
    title: '跨境电商年中战报出炉：出海生意为何越来越"卷"',
    channel: 'shangye',
    summary: '蓝海变红海，从拼流量到拼供应链，这一季度的出海答案悄悄变了。',
    date: '2026-09-02',
    readTime: 5,
    views: 41500,
    tags: ['跨境电商', '出海', '供应链', '行业'],
    cover: 'https://readdy.ai/api/search-image?query=cardboard%20parcel%20boxes%20with%20shipping%20labels%20stacked%20in%20warm%20warehouse%20light%2C%20editorial%20photography%20about%20cross%20border%20ecommerce%2C%20cream%20and%20orange%20tonal%20palette%2C%20clean%20and%20orderly%20composition&width=800&height=520&seq=chigua-shangye-export&orientation=landscape',
    author: '吃瓜·南枝',
    content: [
      '年中战报一出，出海圈的气氛有些微妙：大盘数据依旧漂亮，可单量增速放缓、利润被物流与投放成本摊薄的声音也不少。曾经躺着赚钱的蓝海，肉眼可见地变红了。',
      '细看各家的打法会发现，竞争的主战场已从"投流抢量"转向"供应链与履约"。谁能把商品周转做快、把海外仓布局做好、把客服响应做及时，谁才能把复购率攥在手里。',
      '出海生意的本质是"信任的跨海传输"。当流量红利退去，拼的就是谁更能把优质供给稳定地送到海外消费者面前。这条路没有捷径，但扎实做下去的人，终会等来复利。',
    ],
  },
  {
    slug: 'cheng-shi-ye-xiao-bao-ming',
    title: '城市夜校报名火爆：年轻人补课的下一站，是兴趣与松弛感',
    channel: 'redian',
    summary: '白天上班、晚上学手艺，均价几十块的夜校，成了年轻人精神减压的新出口。',
    date: '2026-09-06',
    readTime: 4,
    views: 97800,
    hotTag: '新',
    tags: ['夜校', '兴趣课', '年轻人', '生活方式'],
    cover: 'https://readdy.ai/api/search-image?query=cozy%20evening%20classroom%20with%20warm%20lamp%20light%20pottery%20tools%20and%20art%20supplies%20on%20tables%2C%20editorial%20lifestyle%20photography%2C%20cream%20and%20amber%20tones%2C%20calm%20and%20inviting%20composition%2C%20no%20people&width=800&height=520&seq=chigua-redian-night&orientation=landscape',
    author: '吃瓜·果壳',
    content: [
      '"下班后去上课"正在成为一线城市年轻人的新流行。从陶艺、烘焙到声乐、书法，报名往往一开放就被抢空，课程均价不高，图的是放松与陪伴。',
      '一位连续上了三期课的学员说，这里没有考勤也没有业绩压力，纯粹是给自己留一段"不用讲道理"的时间，焦虑反而在动手的专注里慢慢消解了。',
      '夜校的火爆，折射的是年轻人对"有意义地度过时间"的渴望。它未必能教会一身本领，却提供了一个低门槛的出口：在白天之外的八小时，重新确认自己对生活依然有掌控感。',
    ],
  },
  {
    slug: 'she-qu-shi-tang-chu-quan',
    title: '出圈的社区食堂：一顿饭钱吃出幸福感的背后',
    channel: 'redian',
    summary: '明厨亮灶、价平量足，社区食堂凭什么成了附近居民和打工人的心头好。',
    date: '2026-09-05',
    readTime: 4,
    views: 54700,
    tags: ['社区食堂', '生活', '物价', '便民'],
    cover: 'https://readdy.ai/api/search-image?query=bright%20clean%20community%20canteen%20with%20steaming%20food%20counter%20and%20warm%20lighting%2C%20editorial%20documentary%20photography%2C%20cream%20and%20orange%20tones%2C%20welcoming%20and%20fresh%20composition%2C%20no%20people&width=800&height=520&seq=chigua-redian-canteen&orientation=landscape',
    author: '吃瓜·小满',
    content: [
      '当外卖价格一路看涨，越来越多社区食堂走进了年轻人的生活。几块钱到十几块一餐、明码标价、现炒现卖，让这里从"老人专属"变成了"全龄友好"的热门去处。',
      '有食堂在饭点排队到门外，靠的是实惠与踏实：菜品透明可见，口味家常，还经常针对周边上班族推出小份拼菜。',
      '社区食堂的出圈，是人们对"吃得省心、吃得体面"需求的回归。当生活半径里能有一处既便宜又安心的吃饭地，那种朴素的幸福感，确实很难用外卖软件上的满减来替代。',
    ],
  },
  {
    slug: 'lu-ying-hou-lu-ye-jing-ji',
    title: '露营降温之后：户外人又悄悄爱上什么新玩法',
    channel: 'redian',
    summary: '一场装备热潮退去，真正沉淀下来的，是日常化的轻量户外生活。',
    date: '2026-09-03',
    readTime: 4,
    views: 46800,
    tags: ['露营', '户外', '轻量化', '趋势'],
    cover: 'https://readdy.ai/api/search-image?query=minimal%20outdoor%20picnic%20setup%20on%20meadow%20with%20portable%20chair%20and%20thermos%20in%20golden%20afternoon%20light%2C%20editorial%20lifestyle%20photography%2C%20cream%20and%20amber%20tones%2C%20relaxed%20and%20airy%20composition%2C%20no%20people&width=800&height=520&seq=chigua-redian-camp&orientation=landscape',
    author: '吃瓜·拾一',
    content: [
      '还记得前两年朋友圈里铺天盖地的精致露营吗？如今那波"搬家式"装备热明显降温，可别急着说户外凉了——它只是从"晒装备"转向了"过日子"。',
      '现在的户外爱好者更青睐轻量化：一张折叠椅、一只保温壶，或者干脆是一场说走就走的一日徒步。装备越来越简单，出门的频率却越来越高。',
      '这轮变化的本质，是户外从"节庆式的仪式感"回归到"日常化的生活方式"。当人们不再为了发圈而进山，而是为了呼吸与放空而出发，户外这件事，才算真正扎进了生活里。',
    ],
  },
];

export const picks: string[] = [
  'ding-liu-zhuan-xing-dian-ying',
  'gu-zhuang-da-ju-shou-bo',
  'zhi-bo-jian-jia-ge-wu-long',
  'cheng-shi-ye-xiao-bao-ming',
];

export const faqs: { q: string; a: string }[] = [
  {
    q: '吃瓜日报多久更新一次？',
    a: '我们会结合当日热点进行整理，工作日每日更新「今日合集」，晚间补充追踪进展与遗漏瓜料；周末则以盘点与专题为主。建议把首页或合集页加入收藏，第一时间看到新内容。',
  },
  {
    q: '同一事件为什么会有不同说法？',
    a: '娱乐与热点事件常存在多方信息源与时间差。我们会以官方口径、当事人声明和可核实的公开信息为优先依据，在正文中标注进度；情况不明时宁可不写猜测，也不做无依据的定论。',
  },
  {
    q: '文章里的信息可靠吗？',
    a: '每篇内容都基于公开可查的信息编辑整理，涉及争议事件会尽量标注来源与时间点。如果你发现事实有出入，欢迎通过联系我们页反馈，我们会在核实后第一时间修正并补充更正说明。',
  },
  {
    q: '可以把你们的文章转载到其他平台吗？',
    a: '可以转载，但请注明出处并保留原文链接与作者信息，同时不要修改标题和核心事实。商业用途或大批量转载前，请先与我们联系取得授权。',
  },
  {
    q: '如何联系吃瓜日报的编辑团队？',
    a: '你可以在关于我们的页面找到官方邮箱与社交账号。投稿爆料、版权合作与意见反馈都可以发邮件给我们，工作日一般会在 1–2 天内回复。',
  },
];

export const todayFeeds = ['ding-liu-zhuan-xing-dian-ying', 'zongyi-ming-chang-mian-fupan', 'gu-zhuang-da-ju-shou-bo', 'zhi-bo-jian-jia-ge-wu-long', 'yan-chang-hui-qiang-piao', 'cheng-shi-ye-xiao-bao-ming', 'guo-chan-shou-ji-ying-xiang', 'ai-huan-lian-sheng-ji'];

export const getItem = (slug: string): GossipItem | undefined =>
  gossipItems.find((i) => i.slug === slug);

export const byChannel = (key: ChannelKey): GossipItem[] =>
  gossipItems.filter((i) => i.channel === key);